export class EventMilestone2PaymentBatchExportZip {
  LineItemId!: string;
  EventRegistrationID!: string;
  EventName!: string;
  CountryName!: string;
  CustomerName!: string;
  PartnerName!: string;
  PartnerID!: string;
  RequestDate!: string;
  FiscalYear!: string;
  DateSubmittedPST!: string;
  EventStatus!: string;
  PartnerOneID!: string;
  PartnerLocation!: string;
  PayeeID!: string;
  WorkshopCompletionDate!: string;
  POECompletionDate!: string;
  EventCompletionDate!: string;
  PaymentType!: string;
  Tier1PaymentAmount!: string;
  Tier1MetDate!: string;
  Tier1PaidDate!: string;
  Tier1MaturityDate!: string;
  Tier1MaturityStatus!: string;
  Tier1Target!: string;
  Tier1MSInvoiceNumber!: string;
  Tier1MSInvoiceDate!: string;
  Tier1PaymentCentralTransactionID!: string;
  Tier1PaymentDocumentNumber!: string;
  Tier2PaymentAmount!: string;
  Tier2MetDate!: string;
  Tier2PaidDate!: string;
  Tier2MaturityDate!: string;
  Tier2MaturityStatus!: string;
  Tier2Target!: string;
  Tier2MSInvoiceNumber!: string;
  Tier2MSInvoiceDate!: string;
  Tier2PaymentCentralTransactionID!: string;
  Tier2PaymentDocumentNumber!: string;
  CompletionDate!: Date;
  PaymentAmount!: string;
  EvaluatedMonth!: string;
  NetIncrementMAD!: string;
  NetIncrementLicenses!: string;
  MaturityDate!: string;
  MaturityStatus!: string;
  Target!: string;
}
export type DynamicProperties = Record<string, string>;

export class milestone2PaymentBatchExportZip {
  constructor(data: DynamicProperties) {
    Object.assign(this, data);
  }
}
